import React from 'react';

import { Box, Text } from '@chakra-ui/react';

type PaginationButtonProps = {
  text: string;
  active: boolean;
  onClick: () => void;
};

export const PaginationButton = ({ active, text, onClick }: PaginationButtonProps) => {
  return (
    <Box
      onClick={() => (active ? onClick() : null)}
      cursor={active ? 'pointer' : 'initial'}
      userSelect={active ? 'initial' : 'none'}
      p={{
        base: 0,
        xs: 2,
      }}
    >
      <Text
        variant={{
          base: 'text-sm/lineHeight-5/font-semibold',
          xs: 'text-md/lineHeight-6/font-semibold',
        }}
        whiteSpace={{
          base: 'normal',
          xs: 'nowrap',
        }}
        color={active ? 'violet.500' : 'transparent'}
      >
        {text}
      </Text>
    </Box>
  );
};
